import { IsDefined, IsEnum, IsNotEmpty, IsObject, IsOptional, IsString } from '@lgce/class-validator';
import { Expose } from 'class-transformer';
import { OfferType } from '../types/offer-type';
import { IsValidForSAPOfferType } from '../decorators';

export class CreateSubscriptionDto {
    @Expose()
    public id!: string;

    @IsDefined()
    @IsNotEmpty()
    @IsString()
    @Expose()
    public label!: string;

    @IsDefined()
    @IsNotEmpty()
    @IsEnum(OfferType)
    @Expose()
    public offerType!: OfferType;

    @IsObject()
    @IsDefined()
    @IsValidForSAPOfferType()
    @Expose()
    public config!: Record<string, unknown>;

    @IsOptional()
    @Expose()
    public comment?: string;

    @IsDefined()
    @IsNotEmpty()
    @IsString()
    @Expose()
    public agencyId!: string;
}
